import React from "react";

const moneyValue = (value) => {
  if (typeof value !== "number" && typeof value !== "string") return null;
  if (String(value).trim() === "") return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

export default function BookingFinancials({ reservation, pms }) {
  // RNS supplies 1/0 payment-status markers in these fields, not dollar amounts.
  if (pms === "RNS") return null;

  // PMS adapters normalize total and balance/amount owed to these fields.
  // rent_paid is a payment amount, not a separate base-rent value.
  const rows = [
    { label: "Rent Total", amount: moneyValue(reservation.rent_total) },
    { label: "Balance Due", amount: moneyValue(reservation.rent_owed), balance: true },
  ].filter(({ amount }) => amount !== null);

  if (!rows.length) return null;

  return (
    <dl className="message-booking-financials" aria-label="Booking financials">
      {rows.map(({ label, amount, balance }) => (
        <div key={label} className={balance ? `message-balance-due ${amount > 0 ? "is-pending" : "is-settled"}` : ""}>
          <dt>{label}</dt>
          <dd>{amount.toLocaleString("en-US", {
            style: "currency", currency: "USD",
          })}</dd>
        </div>
      ))}
    </dl>
  );
}
